var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12px",
    height: "12px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(19, 194, 194)",
    d: "M10.839,10.056 L8.867,8.084 C9.548,7.232 9.958,6.154 9.958,4.980 C9.957,2.230 7.729,0.000 4.979,0.000 C2.228,0.000 -0.000,2.230 -0.000,4.978 C-0.000,7.727 2.230,9.957 4.979,9.957 C6.154,9.957 7.233,9.547 8.084,8.865 L10.055,10.837 C10.271,11.053 10.621,11.053 10.838,10.837 C11.055,10.622 11.055,10.272 10.839,10.056 L10.839,10.056 ZM4.979,8.850 C2.840,8.850 1.106,7.117 1.106,4.978 C1.106,2.840 2.840,1.106 4.979,1.106 C7.117,1.106 8.851,2.840 8.851,4.978 C8.851,7.117 7.117,8.850 4.979,8.850 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view_icon.018f2419da82c5f73e8354fc9c16873a.svg";
export { ForwardRef as ReactComponent };